import { watch } from "vue";
import { useAuthentication } from "@sazka/ng/authentication/composables/use-authentication";
import { ngFrameworkLoaded } from "@sazka/ng/ng-integration";
import { useNgSession } from "@sazka/ng/ng-session";
import { selfExclusionAfterLogin } from "@sazka/ng/panic-button/core/self-exclusion";
import { playerAccountAfterLogin } from "@sazka/ng/player/player-account";

export const useAfterLoginHooks = async () => {
    if (environment.isInAppView) {
        return;
    }

    const { isLoggedIn } = useNgSession();
    const { limitedAccountAfterLogin } = useAuthentication();

    await ngFrameworkLoaded();
    watch(isLoggedIn, async (loggedIn) => {
        // The popups have order of priority (only the highest priority one should be shown)
        // Trigger these checks exactly in this order
        if (await playerAccountAfterLogin(loggedIn)) return;
        if (await selfExclusionAfterLogin(loggedIn)) return;
        limitedAccountAfterLogin();
    });
};
